// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 1H7.58579L3 5.58579V23H21V1ZM10.0039 8.99805V11.002H8V8.99805H10.0039ZM11 14V9H13V14H11ZM8 17V12H10V17H8ZM16 17H14V12H16V17ZM14 8.99805H16.0039V11.002H14V8.99805ZM13.002 14.998V17.002H10.998V14.998H13.002Z"}}]};

const SimCardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sim-card-filled',
    ref,
    icon: element,
  },
));

SimCardFilledIcon.displayName = 'SimCardFilledIcon';

export default SimCardFilledIcon;
